/**
 * «Anzeigen» des verdeckten API-Tokens auf der API-Seite (UC-023 A2, GR-003): ohne JavaScript lädt der Link die Seite
 * mit dem API-Token im Klartext neu; mit JavaScript werden alle Felder mit data-voll im Bereich ohne neues Laden
 * aufgedeckt, also auch das API-Token in der API-Anleitung.
 */
export function anzeigenEinrichten(bereich: ParentNode, knopf: HTMLElement): void {
  knopf.addEventListener('click', (ereignis) => {
    ereignis.preventDefault();
    bereich.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('[data-voll]').forEach((feld) => {
      feld.value = feld.dataset.voll ?? feld.value;
    });
    knopf.hidden = true;
  });
}
